export enum GlobalRoutes {
  LOGIN = "/login",
  LOGOUT = "/logout",
  ForgotPassword = "/forgot-password",
  ResetPassword = "/reset-password/:token",
  PAGE_404 = "/404",
}

export enum ContentRoutes {
  DASHBOARD = "/dashboard",
  VIEW_UPDATE_PROFILE = "/my-profile",

  LOGOUT = "/logout",
  STORES = "/stores",
  COMPANIES = "/companies",
  CREATE_COMPANY = "/company/create",
  UPDATE_COMPANY = "/company/update/:id",
  SONGS = "/song-library",
  CREATE_SONG = "/song",
  UPDATE_SONG = "/song/:id",
  MEDIAS = "/medias",
  CREATE_MEDIA = "/media",
  UPDATE_MEDIA = "/media/:id",
  CHARTS = "/charts",
  CREATE_CHART = "/chart",
  UPDATE_CHART = "/chart/:id",
  ADD_SONGS_TO_CHART = "/add-songs-to-chart/:id",
  MUSIC_SCHEDULES = "/music-schedules",
  CREATE_MUSIC_SCHEDULE = "/music-schedule",
  UPDATE_MUSIC_SCHEDULE = "/music-schedule/:id",
  ADD_SONGS_TO_MUSIC_SCHEDULE = "/add-songs-to-music-schedule/:id",
  COMMERCIAL_SCHEDULES = "/commercial-schedules",
  CREATE_COMMERCIAL_SCHEDULE = "/commercial-schedule",
  UPDATE_COMMERCIAL_SCHEDULE = "/commercial-schedule/:id",
  ADD_ITEMS_TO_COMMERCIAL_SCHEDULE = "/add-items-to-commercial-schedule/:id",
  STORE_SCHEDULE = "/store-schedule",
  SINGERS = "/singers",
  COMPOSERS = "/composers",
  LYRICISTS = "/lyricists",
  ACTORS = "/actors",
  BRANDS = "/brands",
  CAMPAIGNS = "/campaigns",
  PAGE_401 = "/401",
  COMMERCIALS = "/commercials",
  CREATE_COMMERCIAL = "/commercial",
  UPDATE_COMMERCIAL = "/commercial/:id",

  MEDIA_PLAY_REPORT = "/media-play-report",
}

export const ContentIdRoutes = [
  { path: "/user/update/:id" },
  { path: "/company/update/:id" },
];

export enum ContentApiRoutes {
  CREATE_NOTIFICATION = "/notification",
  UPDATE_NOTIFICATION = "/notification/:id",
  DELETE_NOTIFICATION = "/notification/:id",
  VIEW_NOTIFICATION = "/notifications/:id",
  NOTIFICATION = "/notification",
  NOTIFICATION_COUNT = "/new-notification-count",
  READ_NOTIFICATION = "/read-notifications",
  RECIEVE_NOTIFICATION = "/received-notifications",
  LOGIN_ADMIN = "/login-admin",
  DASHBOARD_ADMIN_AGG_REPORT = "/admin-aggregate-report",
  DASHBOARD_AGG_REPORT = "/aggregate-report",
  COUNTRIES = "/countries",
  STATES = "/states",
  CITIES = "/cities",
  AADMIN_THEMES = "/admin-themes",
  AREAS = "/areas",
  ADD_AREA = "/area",
  UPDATE_AREA = "/area/",
  BUILDINGS = "/buildings",
  ADD_BUILDING = "/building",
  UPDATE_BUILDING = "/building/",
  RESET_PASSWORD_LINK = "/generate-reset-password-link",
  RESET_PASSWORD_TOKEN = "/reset-password-by-token",
  VALIDATE_PASSWORD_TOKEN = "/validate-password-token",
  CHANGE_PASSWORD = "/change-password",
  CHANGE_USER_SETTINGS = "/save-settings",
  GET_USER_SETTINGS = "/my-settings",
  LOGOUT = "/logout",
  STORE_GROUPS = "/store-groups",
  REGIONS = "/regions",
  STORES = "/stores",
  VIEW_STORE = "/stores/:id",
  LOGGED_IN_USER_DETAIL = "/me",
  DELETE_USER_IMAGE = "/delete-user-image/:id",
  VIEW_USER = "/users/:id",
  UPLOAD_USER_IMAGE = "/user/:id",
  USERS = "/users",

  SONGS = "/songs",
  SONG = "/song",
  CREATE_SONG = "/song",
  UPDATE_SONG = "/song/:id",
  DELETE_SONG = "/song/:id",
  VIEW_SONG = "/songs/:id",
  EXPORT_SONGS = "/export-songs",
  PUBLISH_SONG = "/publish-song/:id",
  PUBLISH_BULK_SONG = "/publish-bulk-song/",
  DELETE_BULK_SONG = "/delete-bulk-song/",
  DELETE_SONG_LOGO = "/delete-song-logo/:id",

  MEDIAS = "/medias",
  MEDIA = "/media",
  CREATE_MEDIA = "/media",
  UPDATE_MEDIA = "/media/:id",
  DELETE_MEDIA = "/media/:id",
  VIEW_MEDIA = "/medias/:id",

  COMMERCIALS = "/commercials",
  COMMERCIAL = "/commercial",
  CREATE_COMMERCIAL = "/commercial",
  UPDATE_COMMERCIAL = "/commercial/:id",
  DELETE_COMMERCIAL = "/commercial/:id",
  VIEW_COMMERCIAL = "/commercials/:id",
  EXPORT_COMMERCIALS = "/export-commercials",
  PUBLISH_COMMERCIAL = "/publish-commercial/:id",
  PUBLISH_BULK_COMMERCIAL = "/publish-bulk-commercial/",
  DELETE_BULK_COMMERCIAL = "/delete-bulk-commercial/",
  DELETE_COMMERCIAL_LOGO = "/delete-commercial-logo/:id",
  UPLOAD_COMMERCIAL_LOGO = "/commercial/:id",

  CHARTS = "/charts",
  CHART_SONGS = "/chart-songs/:id",
  CHART = "/chart",
  CREATE_CHART = "/chart",
  UPDATE_CHART = "/chart/:id",
  DELETE_CHART = "/chart/:id",
  VIEW_CHART = "/charts/:id",
  ADD_SONGS_TO_CHART = "/add-songs-to-chart/:id",
  PUBLISH_CHART = "/publish-chart/:id",
  DELETE_SONGS_FROM_CHART = "/delete-songs-from-chart/:id",
  DELETE_CHART_LOGO = "/delete-chart-logo/:id",

  MUSIC_SCHEDULES = "/music-schedules",
  MUSIC_SCHEDULE_SONGS = "/music-schedule-songs/:id",
  MUSIC_SCHEDULE = "/music-schedule",
  CREATE_MUSIC_SCHEDULE = "/music-schedule",
  UPDATE_MUSIC_SCHEDULE = "/music-schedule/:id",
  DELETE_MUSIC_SCHEDULE = "/music-schedule/:id",
  VIEW_MUSIC_SCHEDULE = "/music-schedules/:id",
  ADD_SONGS_TO_MUSIC_SCHEDULE = "/add-songs-to-music-schedule/:id",
  PUBLISH_MUSIC_SCHEDULE = "/publish-music-schedule/:id",
  DELETE_SONGS_FROM_MUSIC_SCHEDULE = "/delete-songs-from-music-schedule/:id",
  DELETE_TIME_SLOT = "/time-slot/:id",

  COMMERCIAL_SCHEDULES = "/commercial-schedules",
  COMMERCIAL_SCHEDULE = "/commercial-schedule",
  COMMERCIAL_SCHEDULE_ITEMS = "/commercial-schedule-items/:id",
  CREATE_COMMERCIAL_SCHEDULE = "/commercial-schedule",
  UPDATE_COMMERCIAL_SCHEDULE = "/commercial-schedule/:id",
  DELETE_COMMERCIAL_SCHEDULE = "/commercial-schedule/:id",
  VIEW_COMMERCIAL_SCHEDULE = "/commercial-schedules/:id",
  ADD_ITEMS_TO_COMMERCIAL_SCHEDULE = "/add-item-to-commercial-schedule/:id",
  PUBLISH_COMMERCIAL_SCHEDULE = "/publish-commercial-schedule/:id",
  DELETE_ITEMS_FROM_COMMERCIAL_SCHEDULE = "/delete-items-from-commercial-schedule/:id",

  STORE_SCHEDULE = "/store-schedule",
  STORE_SCHEDULE_FROM_ADMIN = "/store-schedule-from-admin",

  MEDIA_PLAY_REPORT = "/media-play-report",
  EXPORT_MEDIA_PLAY_REPORT = "/export-media-play-report",

  ACTORS = "/actors",
  ACTOR = "/actor",
  CREATE_ACTOR = "/actor",
  UPDATE_ACTOR = "/actor/:id",
  DELETE_ACTOR = "/actor/:id",
  PUBLISH_ACTOR = "/publish-actor/:id",
  VIEW_ACTOR = "/actors/:id",

  BRANDS = "/brands",
  BRAND = "/brand",
  CREATE_BRAND = "/brand",
  UPDATE_BRAND = "/brand/:id",
  DELETE_BRAND = "/brand/:id",
  PUBLISH_BRAND = "/publish-brand/:id",
  VIEW_BRAND = "/brands/:id",

  CAMPAIGNS = "/campaigns",
  CAMPAIGN = "/campaign",
  CREATE_CAMPAIGN = "/campaign",
  UPDATE_CAMPAIGN = "/campaign/:id",
  DELETE_CAMPAIGN = "/campaign/:id",
  PUBLISH_CAMPAIGN = "/publish-campaign/:id",
  VIEW_CAMPAIGN = "/campaigns/:id",

  COMPOSERS = "/composers",
  COMPOSER = "/composer",
  CREATE_COMPOSER = "/composer",
  UPDATE_COMPOSER = "/composer/:id",
  DELETE_COMPOSER = "/composer/:id",
  PUBLISH_COMPOSER = "/publish-composer/:id",
  VIEW_COMPOSER = "/composers/:id",

  ERAS = "/eras",
  ERA = "/era",
  CREATE_ERA = "/era",
  UPDATE_ERA = "/era/:id",
  DELETE_ERA = "/era/:id",
  PUBLISH_ERA = "/publish-era/:id",
  VIEW_ERA = "/eras/:id",

  EVENTS = "/events",
  EVENT = "/event",
  CREATE_EVENT = "/event",
  UPDATE_EVENT = "/event/:id",
  DELETE_EVENT = "/event/:id",
  PUBLISH_EVENT = "/publish-event/:id",
  VIEW_EVENT = "/events/:id",

  FESTIVE_SEASONS = "/festive-seasons",
  FESTIVE_SEASON = "/festive-season",
  CREATE_FESTIVE_SEASON = "/festive-season",
  UPDATE_FESTIVE_SEASON = "/festive-season/:id",
  DELETE_FESTIVE_SEASON = "/festive-season/:id",
  PUBLISH_FESTIVE_SEASON = "/publish-festive-season/:id",
  VIEW_FESTIVE_SEASON = "/festive-seasons/:id",

  GENRES = "/genres",
  GENRE = "/genre",
  CREATE_GENRE = "/genre",
  UPDATE_GENRE = "/genre/:id",
  DELETE_GENRE = "/genre/:id",
  PUBLISH_GENRE = "/publish-genre/:id",
  VIEW_GENRE = "/genres/:id",

  LABELS = "/labels",
  LABEL = "/label",
  CREATE_LABEL = "/label",
  UPDATE_LABEL = "/label/:id",
  DELETE_LABEL = "/label/:id",
  PUBLISH_LABEL = "/publish-label/:id",
  VIEW_LABEL = "/labels/:id",

  LANGUAGES = "/languages",
  LANGUAGE = "/language",
  CREATE_LANGUAGE = "/language",
  UPDATE_LANGUAGE = "/language/:id",
  DELETE_LANGUAGE = "/language/:id",
  PUBLISH_LANGUAGE = "/publish-language/:id",
  VIEW_LANGUAGE = "/languages/:id",

  LICENSES = "/licenses",
  LICENSE = "/license",
  CREATE_LICENSE = "/license",
  UPDATE_LICENSE = "/license/:id",
  DELETE_LICENSE = "/license/:id",
  PUBLISH_LICENSE = "/publish-license/:id",
  VIEW_LICENSE = "/license/:id",

  LYRICISTS = "/lyricists",
  LYRICIST = "/lyricist",
  CREATE_LYRICIST = "/lyricist",
  UPDATE_LYRICIST = "/lyricist/:id",
  DELETE_LYRICIST = "/lyricist/:id",
  PUBLISH_LYRICIST = "/publish-lyricist/:id",
  VIEW_LYRICIST = "/lyricist/:id",

  MOODS = "/moods",
  MOOD = "/mood",
  CREATE_MOOD = "/mood",
  UPDATE_MOOD = "/mood/:id",
  DELETE_MOOD = "/mood/:id",
  PUBLISH_MOOD = "/publish-mood/:id",
  VIEW_MOOD = "/mood/:id",

  RATING_CHARTS = "/rating-charts",
  RATING_CHART = "/rating-chart",
  CREATE_RATING_CHART = "/rating-chart",
  UPDATE_RATING_CHART = "/rating-chart/:id",
  DELETE_RATING_CHART = "/rating-chart/:id",
  PUBLISH_RATING_CHART = "/publish-rating-chart/:id",
  VIEW_RATING_CHART = "/rating-chart/:id",

  SINGERS = "/singers",
  SINGER = "/singer",
  CREATE_SINGER = "/singer",
  UPDATE_SINGER = "/singer/:id",
  DELETE_SINGER = "/singer/:id",
  PUBLISH_SINGER = "/publish-singer/:id",
  VIEW_SINGER = "/singer/:id",

  TEMPOS = "/tempos",
  TEMPO = "/tempo",
  CREATE_TEMPO = "/tempo",
  UPDATE_TEMPO = "/tempo/:id",
  DELETE_TEMPO = "/tempo/:id",
  PUBLISH_TEMPO = "/publish-tempo/:id",
  VIEW_TEMPO = "/tempo/:id",

  COMPANIES = "/companies",
  COMPANY = "/company",
  CREATE_COMPANY = "/company",
  UPDATE_COMPANY = "/company/:id",
  DELETE_COMPANY = "/company/:id",
  VIEW_COMPANY = "/companies/:id",
  EXPORT_COMPANIES = "/export-companies",
  PUBLISH_COMPANY = "/publish-company/:id",
  PUBLISH_BULK_COMPANY = "/publish-bulk-company/",
  DELETE_BULK_COMPANY = "/delete-bulk-company/",
  DELETE_COMPANY_LOGO = "/delete-company-logo/:id",
  UPLOAD_COMPANY_LOGO = "/company/:id",
  COMPANY_TYPES = "/company-types/",
  CREATED_BY_LIST = "/created-by/",
  UPDATE_USER = "/user/:id",
}

export const HIDE_COMPANY_DROP_DOWN = [
  ContentRoutes.COMPANIES,
  ContentRoutes.CREATE_COMPANY,
];

export const GET_POPUP_ENUMS = {
  logout: "logout",
  changePasword: "change-password",
  changeSettings: "change-settings",
  changeTheme: "change-theme",
};
